module.exports = __webpack_public_path__ + "static/media/quicken.8479264c.png";